var cov_2fqwkrp1lh = function () {
  var path = "/Users/spana/SHEIN/shineout/src/Transfer/filter.tsx",
      hash = "746b7dff5cb98ff7559f5d2324c30911837d9823",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/Transfer/filter.tsx",
    statementMap: {
      "0": {
        start: {
          line: 10,
          column: 2
        },
        end: {
          line: 37,
          column: 29
        }
      },
      "1": {
        start: {
          line: 12,
          column: 6
        },
        end: {
          line: 12,
          column: 18
        }
      },
      "2": {
        start: {
          line: 13,
          column: 6
        },
        end: {
          line: 15,
          column: 7
        }
      },
      "3": {
        start: {
          line: 16,
          column: 6
        },
        end: {
          line: 16,
          column: 54
        }
      },
      "4": {
        start: {
          line: 20,
          column: 40
        },
        end: {
          line: 20,
          column: 50
        }
      },
      "5": {
        start: {
          line: 21,
          column: 6
        },
        end: {
          line: 21,
          column: 52
        }
      },
      "6": {
        start: {
          line: 21,
          column: 41
        },
        end: {
          line: 21,
          column: 52
        }
      },
      "7": {
        start: {
          line: 22,
          column: 6
        },
        end: {
          line: 22,
          column: 67
        }
      },
      "8": {
        start: {
          line: 22,
          column: 30
        },
        end: {
          line: 22,
          column: 66
        }
      },
      "9": {
        start: {
          line: 26,
          column: 34
        },
        end: {
          line: 26,
          column: 44
        }
      },
      "10": {
        start: {
          line: 27,
          column: 6
        },
        end: {
          line: 27,
          column: 42
        }
      },
      "11": {
        start: {
          line: 27,
          column: 20
        },
        end: {
          line: 27,
          column: 42
        }
      },
      "12": {
        start: {
          line: 28,
          column: 6
        },
        end: {
          line: 28,
          column: 29
        }
      },
      "13": {
        start: {
          line: 32,
          column: 27
        },
        end: {
          line: 32,
          column: 37
        }
      },
      "14": {
        start: {
          line: 33,
          column: 19
        },
        end: {
          line: 33,
          column: 33
        }
      },
      "15": {
        start: {
          line: 34,
          column: 21
        },
        end: {
          line: 34,
          column: 61
        }
      },
      "16": {
        start: {
          line: 35,
          column: 6
        },
        end: {
          line: 35,
          column: 98
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 9,
            column: 16
          },
          end: {
            line: 9,
            column: 17
          }
        },
        loc: {
          start: {
            line: 10,
            column: 2
          },
          end: {
            line: 37,
            column: 29
          }
        },
        line: 10
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 11,
            column: 4
          },
          end: {
            line: 11,
            column: 5
          }
        },
        loc: {
          start: {
            line: 11,
            column: 84
          },
          end: {
            line: 17,
            column: 5
          }
        },
        line: 11
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 19,
            column: 5
          }
        },
        loc: {
          start: {
            line: 19,
            column: 14
          },
          end: {
            line: 23,
            column: 5
          }
        },
        line: 19
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 22,
            column: 25
          },
          end: {
            line: 22,
            column: 26
          }
        },
        loc: {
          start: {
            line: 22,
            column: 30
          },
          end: {
            line: 22,
            column: 66
          }
        },
        line: 22
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 25,
            column: 4
          },
          end: {
            line: 25,
            column: 5
          }
        },
        loc: {
          start: {
            line: 25,
            column: 31
          },
          end: {
            line: 29,
            column: 5
          }
        },
        line: 25
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 31,
            column: 5
          }
        },
        loc: {
          start: {
            line: 31,
            column: 13
          },
          end: {
            line: 36,
            column: 5
          }
        },
        line: 31
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 52
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 52
          }
        }, {
          start: {
            line: 21,
            column: 6
          },
          end: {
            line: 21,
            column: 52
          }
        }],
        line: 21
      },
      "1": {
        loc: {
          start: {
            line: 21,
            column: 10
          },
          end: {
            line: 21,
            column: 39
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 21,
            column: 10
          },
          end: {
            line: 21,
            column: 19
          }
        }, {
          start: {
            line: 21,
            column: 23
          },
          end: {
            line: 21,
            column: 39
          }
        }],
        line: 21
      },
      "2": {
        loc: {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 42
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 42
          }
        }, {
          start: {
            line: 27,
            column: 6
          },
          end: {
            line: 27,
            column: 42
          }
        }],
        line: 27
      },
      "3": {
        loc: {
          start: {
            line: 34,
            column: 21
          },
          end: {
            line: 34,
            column: 61
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 34,
            column: 32
          },
          end: {
            line: 34,
            column: 49
          }
        }, {
          start: {
            line: 34,
            column: 52
          },
          end: {
            line: 34,
            column: 61
          }
        }],
        line: 34
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
var _jsxFileName = "/Users/spana/SHEIN/shineout/src/Transfer/filter.tsx";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React from 'react';
import { Component } from '../component';
export default (function (Origin) {
  cov_2fqwkrp1lh.f[0]++;
  cov_2fqwkrp1lh.s[0]++;
  return (
    /*#__PURE__*/
    function (_Component) {
      _inherits(_class, _Component);

      var _super = _createSuper2(_class);

      function _class(props) {
        var _this;

        _classCallCheck(this, _class);

        cov_2fqwkrp1lh.f[1]++;
        cov_2fqwkrp1lh.s[1]++;
        _this = _super.call(this, props);
        cov_2fqwkrp1lh.s[2]++;
        _this.state = {
          text: ''
        };
        cov_2fqwkrp1lh.s[3]++;
        _this.handleFilter = _this.handleFilter.bind(_assertThisInitialized(_this));
        return _this;
      }

      _createClass(_class, [{
        key: "getData",
        value: function getData() {
          var _this2 = this;

          cov_2fqwkrp1lh.f[2]++;

          var _ref = (cov_2fqwkrp1lh.s[4]++, this.props),
              onFilter = _ref.onFilter,
              data = _ref.data,
              index = _ref.index;

          cov_2fqwkrp1lh.s[5]++;

          if ((cov_2fqwkrp1lh.b[1][0]++, !onFilter) || (cov_2fqwkrp1lh.b[1][1]++, !this.state.text)) {
            cov_2fqwkrp1lh.b[0][0]++;
            cov_2fqwkrp1lh.s[6]++;
            return data;
          } else {
            cov_2fqwkrp1lh.b[0][1]++;
          }

          cov_2fqwkrp1lh.s[7]++;
          return data.filter(function (d) {
            cov_2fqwkrp1lh.f[3]++;
            cov_2fqwkrp1lh.s[8]++;
            return onFilter(_this2.state.text, d, !index);
          });
        }
      }, {
        key: "handleFilter",
        value: function handleFilter(text) {
          cov_2fqwkrp1lh.f[4]++;

          var _ref2 = (cov_2fqwkrp1lh.s[9]++, this.props),
              onSearch = _ref2.onSearch,
              index = _ref2.index;

          cov_2fqwkrp1lh.s[10]++;

          if (onSearch) {
            cov_2fqwkrp1lh.b[2][0]++;
            cov_2fqwkrp1lh.s[11]++;
            onSearch(text, !index);
          } else {
            cov_2fqwkrp1lh.b[2][1]++;
          }

          cov_2fqwkrp1lh.s[12]++;
          this.setState({
            text: text
          });
        }
      }, {
        key: "render",
        value: function render() {
          cov_2fqwkrp1lh.f[5]++;

          var _ref3 = (cov_2fqwkrp1lh.s[13]++, this.props),
              onFilter = _ref3.onFilter;

          var data = (cov_2fqwkrp1lh.s[14]++, this.getData());
          var filter = (cov_2fqwkrp1lh.s[15]++, onFilter ? (cov_2fqwkrp1lh.b[3][0]++, this.handleFilter) : (cov_2fqwkrp1lh.b[3][1]++, undefined));
          cov_2fqwkrp1lh.s[16]++;
          return (
            /*#__PURE__*/
            React.createElement(Origin, Object.assign({}, this.props, {
              onFilter: filter,
              filterText: this.state.text,
              data: data,
              __self: this,
              __source: {
                fileName: _jsxFileName,
                lineNumber: 35,
                columnNumber: 14
              }
            }))
          );
        }
      }]);

      return _class;
    }(Component)
  );
});